"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRafState = void 0;
const react_1 = require("react");
const use_on_unmount_1 = require("./use-on-unmount");
function useRafState(initialState) {
    const frame = (0, react_1.useRef)(0);
    const [state, setState] = (0, react_1.useState)(initialState);
    const setRafState = (0, react_1.useCallback)((value) => {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(() => {
            setState(value);
        });
    }, []);
    (0, use_on_unmount_1.useOnUnmount)(() => cancelAnimationFrame(frame.current));
    return [state, setRafState];
}
exports.useRafState = useRafState;
